import React from 'react';
import CharacterObject from 'game/scenes/test/CharacterObject';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function CharacterObjectPage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [CharacterObject],
            physics: {
              arcade: {
                gravity: { y: 0 },
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
